import { useQuery, type QueryObserverResult, type RefetchOptions } from "@tanstack/react-query";
import { getEmployeeSchedule } from "../api/api";
import type { ErrorMessage, GetEmployeeScheduleResponse } from "../types/types";
import { type Dayjs } from "dayjs";
export type UseGetEmployeeScheduleReturn = {
  employeeScheduleData: GetEmployeeScheduleResponse | undefined;
  branchId: number;
  loading: boolean;
  refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<GetEmployeeScheduleResponse, ErrorMessage>>;
  error: ErrorMessage | null;
};

type useGetEmployeeScheduleProps = {
  date: Dayjs;
  duration: number;
};

export const useGetEmployeeSchedule = ({
  date,
  duration,
}: useGetEmployeeScheduleProps): UseGetEmployeeScheduleReturn => {
  const branchId = Number(location.pathname.split("/").at(-1));
  const formattedDate = date.format("YYYY-MM-DD");

  const { data, isLoading, isFetching, error, refetch } = useQuery<GetEmployeeScheduleResponse, ErrorMessage>({
    queryKey: ["employee-schedule", branchId, formattedDate, duration],
    queryFn: () => getEmployeeSchedule({ branchId: branchId, date: formattedDate, duration }),
    staleTime: 0,
  });

  const loading = isLoading || isFetching;

  return {
    employeeScheduleData: data,
    branchId,
    loading,
    refetch,
    error,
  };
};
export default useGetEmployeeSchedule;
